import React from 'react';
import SectionHeading from './SectionHeading';

const Education = function({ lang, isDark, sections, education }) {
  return (
    <section id="education" className="mb-8" aria-labelledby="edu-heading">
      <div className="section-card">
        <SectionHeading id="edu-heading" isDark={isDark}>{sections.education}</SectionHeading>
        <div className="space-y-7">
          {education.map((edu, i) => (
            <div key={i} className="flex flex-col gap-2">
              <h3 className={`text-[14px] font-bold leading-snug ${isDark ? 'text-slate-200' : 'text-slate-800'}`}>{edu.degree}</h3>
              <p className={`text-[13px] font-medium ${isDark ? 'text-slate-400' : 'text-slate-600'}`}>{edu.institution}</p>
              <p className={`text-[11px] font-mono ${isDark ? 'text-slate-500' : 'text-slate-500'}`}>{edu.period}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default React.memo(Education);
